// extracted by mini-css-extract-plugin
module.exports = {"boxDropdown":"EBNyg9wFSzm2qCe4S7BjN","content":"PECN6LZT-pv6-9u4UY4jl"};